import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IDoesFilterPassParams, IFilterParams, RowNode } from 'ag-grid-community';
import { TypingInterval } from 'src/app/constants';

@Component({
  selector: 'app-resource-name-filter',
  templateUrl: './resource-name-filter.component.html',
  styleUrls: ['./resource-name-filter.component.scss']
})
export class ResourceNameFilterComponent implements IFilterAngularComp {

  @ViewChild('eFilterText') eFilterText!: ElementRef;


  params: IFilterParams;

  filterText = '';

  typingTimer: any;

  doneTypingInterval = TypingInterval;

  destroySubscription = false;

  constructor() { }

  agInit(params: IFilterParams): void {
    this.params = params;
  }

  isFilterActive(): boolean {
    return this.filterText != null && this.filterText !== '';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    let passed = true;
    const { node } = params;
    // console.log(params);
    // this.filterText
    //     .toLowerCase()
    //     .split(' ')
    //     .forEach((filterWord) => {
    //         const value = this.params.rowModel.getRow;
    //       console.log(value)
    //         // if (value.toString().toLowerCase().indexOf(filterWord) < 0) {
    //         //     passed = false;
    //         // }
    //     });
    const val = this.filterText.toLowerCase();
    if (!val) {
      passed = false;
    }

    return passed;
  }

  getModel() {
    if (!this.isFilterActive()) {
      return null;
    }

    return { value: this.filterText };
  }

  setModel(model: any) {
    this.filterText = model == null ? null : model.value;
  }

  onInputChanged() {
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(() => {
      this.params.filterChangedCallback();
    }, this.doneTypingInterval);
  }

  destroy() {
    this.destroySubscription = true;
  }

}
